import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { Theme } from "../types/theme";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-divider',
  props: {
    isVertical: { type: Boolean, default: false },
    theme: { default: "light" },
    isStackMedium: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("hr", {
    class: _normalizeClass(["ds-divider", { 'is-vertical': _ctx.isVertical, 'is-dark': _ctx.theme === 'dark', 'is-stack-medium': _ctx.isStackMedium }])
  }, null, 2))
}
}

})